export default __webpack_public_path__ + "img/Stock.2f4d3b05.jpg";